import './BulkUserMainView.scss';
import {ArrDrawer} from '../../common/arr-drawer/ArrDrawer';
import BulkUserListView from './BulkUserListView';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {
  setHandleDrawerOpen,
  setOpenUnsavedModal,
} from '../../../redux/slice/bulkUsersSlice';

type BulkUserMainViewProps = {
  onUsersBulkUpdated?: () => void;
};

const BulkUserMainView: React.FC<BulkUserMainViewProps> = ({
  onUsersBulkUpdated,
}) => {
  const dispatch = useDispatch();

  const isOpen = useSelector(
    (state: RootState) => state.bulkUser.handleDrawerOpen
  );
  const hasUnsaved = useSelector(
    (state: RootState) => state.bulkUser.unSavedDataChanges
  );

  const handleDrawerClose = () => {
    if (hasUnsaved) {
      dispatch(setOpenUnsavedModal(true));
    } else {
      dispatch(setHandleDrawerOpen(false));
      dispatch(setOpenUnsavedModal(false));
    }
  };

  return (
    <ArrDrawer
      showButton
      isOpen={isOpen}
      size="large"
      side="right"
      onClose={handleDrawerClose}
    >
      <div className="bulk-access-container" data-testid={`bulk-user-main-view-div`}>
        <BulkUserListView onUsersBulkUpdated={onUsersBulkUpdated} />
      </div>
    </ArrDrawer>
  );
};

export default BulkUserMainView;
